import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken } from './auth'
import { EventBus } from "@/utils/event-bus";
import errorCode from './errorCode'
import { encrypt, decrypt } from './aes_fun.js';

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: "/HealthManagerApi",
  // baseURL: 'http://192.168.201.173:8080/',
  // 超时
  timeout: 6000 * 1000
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token

  const isToken = (config.headers || {}).isToken === false
  let token = getToken();
  if (token && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken();
  }

  // config.headers['Authorization'] = 'Bearer ' + getToken()



  // delete config.headers['X-Powered-By'];


  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }

  //aes加密
  // if (config.method === 'post' || config.method === 'put') {
  //   config.data = encrypt(JSON.stringify(config.data));
  // }
  return config
}, error => {

  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  //aes解密
  // if (typeof (res.data) == "string") {
  //   res.data = JSON.parse(decrypt(res.data));
  //   //
  // }
  // 未设置状态码则默认成功状态
  const code = res.data.error || 200;
  // 获取错误信息
  // const msg = errorCode[code] || res.data.msg || errorCode['default']
  if (code === 401) {
    Message({
      message: 'Login status has expired, please login again',
      type: 'warning'
    });
    EventBus.$emit("DESTROY_WS")
    router.push("/login");

    if (getToken()) {

      store.dispatch('FedLogOut')
        .then(() => {
          router.push("/login");
      //     store.dispatch("tagsView/delAllViews");
      //     router.push("/login");
        })
        .catch(() => { });
    }
    return Promise.reject()
  }else {
    return res.data
  }
},
  error => {

    let { message } = error;
    if (message == "Network Error") {
      message = "Abnormal connection of back-end interface";
    } else if (message.includes("timeout")) {
      message = "System interface request timeout";
    } else if (message.includes("Request failed with status code")) {
      message = "system interface" + message.substr(message.length - 3) + "abnormal";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
